export default __webpack_public_path__ + "static/media/logo.927fef12.png";